import * as React from 'react';
import { Form, Text, Select, TextArea } from 'react-form';
import Select2 from 'react-select/lib/Creatable';
import { api } from '@src/services/api';
import { checkLevel } from "@src/services/user";
import { _ } from "@src/services/i18n";
import { classNames, css, mixin, vars, defaultProps, formatters } from '@src/services/theme';
import { Box, Modal } from '@src/components';
import Loading from '@src/components/UI/Loading';

export interface LocalProps {
    id: any;
    get: string;
    share: string;
    unshare: string;
    action: "share" | "unshare";
    onSuccess?: Function;
    onCancel?: Function;
}
export interface LocalState {
    custid: any;
    items: any;
    error: any;
}

// style
const style = css`
    form, article {
        ${mixin.form}
    }
`;

// component
export class BatteryShare extends React.Component<LocalProps, LocalState> {
    state = {} as LocalState;

    async componentWillMount() {
        const { action, get } = this.props;
        if (action === "share") {
            const res = await api({
                url: get,
                method: 'get'
            });
            this.setState({
                items: res.data.data
            })
        }
    }

    async save( custid ) {
        const { id, share, onSuccess } = this.props;
        try {
            const res = await api({
                url: share,
                method: 'put',
                params: {
                    battid: id,
                    custid
                }
            });
            if (onSuccess) {
                onSuccess(res);
            }
        } catch(e) {
            this.setState({
                error: e.response.data
            })
        }
    }

    async unshare( ) {
        const { id, unshare, onSuccess } = this.props;
        try {
            const res = await api({
                url: unshare,
                method: 'put',
                params: {
                    battid: id
                }
            });
            if (onSuccess) {
                onSuccess(res);
            }
        } catch(e) {
            this.setState({
                error: e.response.data
            })
        }
    }

    outputError() {
        const { error } = this.state;
        if (!error.errors) { return null; }
        const errors = Object.keys(error.errors).reduce( (acc, e) => {
            return [...acc, ...error.errors[e] ];
        }, [])
        return (
            <div className="errors">
                <div><strong>{error.message}</strong></div>
                <ul>
                    {errors.map( (v,k) => (
                        <li key={k}>{v}</li>
                    ) )}
                </ul>
            </div>
        )
    }
    
	// render
	render() {
        const { id, action, onCancel } = this.props;
        const { custid, items, error } = this.state;
        return (
            <Modal
                title={_(`${action}_battery_title`, 'SettingsBattery') }
                open={true}
                onClose={() => { if (onCancel) onCancel() } }
            >
            {action === "share" &&
                <>
                {!items &&
                <Loading />
                }
                {items &&
                <div className={style}>
                    <Form
                        onSubmit={(v) => this.save(v.custid)}
                    >
                    {formApi => (
                        <form
                            onSubmit={formApi.submitForm}
                            onChange={() => setTimeout(() => { this.setState({ custid: formApi.getFormState().values.custid }); }) }
                        >
                            <div className="fields">
                                <article className="full">
                                    <label htmlFor="custid">{_('field_custid', 'SettingsBattery')}</label>
                                    <Select field={"custid"} id="custid" options={items.map( v => ({ value: v.id, label: `${v.description || ''}` }))} className="form-control" />
                                </article>
                            </div>
                            {error && this.outputError()}
                            <footer>
                                <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                    {_(`btn_cancel`, 'Settings')}
                                </button>
                                <button type="submit" className="btn btn-primary" disabled={!custid}>
                                    {_(`share_battery_btn`, 'SettingsBattery')}
                                </button>
                            </footer>
                        </form>
                    )}
                    </Form>
                </div>
                }
                </>
            }
            {action === "unshare" &&
                <>
                <div className={style}>
                    <article>
                        <footer>
                            <button type="button" className="btn btn-cancel" onClick={() => { if (onCancel) onCancel() } }>
                                {_(`btn_cancel`, 'Settings')}
                            </button>
                            <button type="submit" className="btn btn-primary" onClick={() => { this.unshare() } }>
                                {_(`unshare_battery_btn`, 'SettingsBattery')}
                            </button>
                        </footer>
                    </article>
                </div>
                </>
            }
            </Modal>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Settings/Actions/BatteryShare.tsx